// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!./bootstrap-extended.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("0516ccdf", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/bootstrap-extended.css
// module id = 915
// module chunks = 0